import React from "react";
import { useMatchData } from "../../../../mls-match-list/utils";
import { StyledScorebugPre } from "../StyledScorebug";

export const ScorebugPre = () => {
  const { matchDateTime, isTimeTbd } = useMatchData();
  const { time } = matchDateTime || {};
  return (
    <StyledScorebugPre>
      {isTimeTbd ? (
        <span style={{ textTransform: "uppercase" }}>TBD</span>
      ) : time != null ? (
        <span>{time.replace(" ", "")}</span>
      ) : null}
    </StyledScorebugPre>
  );
};
